import { useState } from 'react';
import { getArticles } from '@/lib/articlesApi';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function TestArticles() {
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const handleFetchList = async () => {
    setLoading(true);
    try {
      console.log('[TestArticles] Fetching articles...');
      const data = await getArticles();
      console.log('[TestArticles] Response:', data);
      setResult({
        count: data?.length || 0,
        translated: data?.[0]?.translated,
        titles: data?.slice(0, 3)?.map((article: any) => article.title) || []
      });
    } catch (error) {
      console.error('[TestArticles] Error:', error);
      setResult({ error: error instanceof Error ? error.message : 'Unknown error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-6">
      <Card>
        <CardHeader>
          <CardTitle>Test Articles API</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={handleFetchList} 
            disabled={loading}
            className="w-full"
          >
            {loading ? 'Fetching...' : 'Fetch list (debug)'}
          </Button>
          
          {result && (
            <div className="bg-muted p-4 rounded-md">
              <pre className="text-sm">
                {JSON.stringify(result, null, 2)}
              </pre>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}